import React from 'react';
import { withRouteData, Route } from 'react-static';
import {TwoColScrollLayout, FlowStripeWrapper, TwoColScrollableContent, TwoColContentLayout, ContentWrapper
} from '@flow/components/ui';
import List from '@flow/scenes/news/components/List';
import ListItem from '@flow/scenes/news/components/ListItem';
import { IPosts } from 'types/IPosts';
import * as NavigationAction from '@flow/store/navigation/actions';
import { connect } from 'react-redux';
import FlowStripe from '@flow/components/ticker/FlowStripe';
import NewsDetail from '@flow/scenes/news/detail/NewsDetail';
import SEOTags from '@flow/components/seo/SEOTags';
import { IPage } from 'types/IPage';
import BasicButton from '@flow/components/ui/button/BasicButton';
import styled from 'styled-components';

const BackButtonWrapper = styled.div`
  @media (min-width: ${props => props.theme.twoColToOneColLayout}px) {
    display: none;
  }
`;

interface Props {
  appLanguage: IAppLanguage;
  page: IPage;
  posts: IPosts;
  slugBases: any;
  _setLanguage: any;
  match: any
}

class News extends React.Component<Props> {

  componentWillMount() {
    const {
      appLanguage,
      _setLanguage,
      page,
    } = this.props;

    const lang_versions = page && page.lang_versions;

    _setLanguage({ appLanguage, lang_versions });
  }

  componentWillReceiveProps({
    appLanguage,
    page,
  }: Props) {
    const {
      _setLanguage,
    } = this.props;

    const lang_versions = page && page.lang_versions;

    _setLanguage({ appLanguage, lang_versions });
  }

  render() {
    const {
      appLanguage,
      posts = [],
      match: {
        url,
        isExact
      },
      page,
    } = this.props;

    return (
      <TwoColScrollLayout>
        <SEOTags page={page} />
        <TwoColScrollableContent width={isExact ? '100%' : `${2/5*100}%`}>
          <List className={!isExact ? 'news-item-active': ''}>
            { posts.map((post, key) => ( <ListItem key={key} post={post} appLanguage={appLanguage} noBorder={true} /> )) }
          </List>
        </TwoColScrollableContent>
        {!isExact && <TwoColContentLayout width={`${3/5*100}%`}>
          <FlowStripeWrapper>
            <FlowStripe animate={true} rotation={90} color={'#000000'} />
          </FlowStripeWrapper>
          <ContentWrapper>
            <BackButtonWrapper>
              <BasicButton label={appLanguage.code === 'fi' ? 'Uutisarkisto' : 'News archive'} href={appLanguage.code === 'fi' ? '/news' : '/en/news'} showAsBackArrow={true}/>
            </BackButtonWrapper>
            <Route path={`${url}/:newsID/`} component={NewsDetail} />
          </ContentWrapper>
        </TwoColContentLayout> }
      </TwoColScrollLayout>
    );
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    _setLanguage: ({appLanguage, lang_versions }: ISetLanguage) => {
      dispatch(NavigationAction.setLanguage(appLanguage, lang_versions));
    }
  }
};

export default connect(
  null,
  mapDispatchToProps
)(withRouteData(News));



// WEBPACK FOOTER //
// /Users/ek1z/dev/flowfestival-com/src/scenes/news/News.tsx